// @ts-nocheck

import { XGInput } from '@xg-cl/xg-cl';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../../utils/currencyHelper';
import { Radio } from '@mui/material';

const RefundTypeItem = ({
  refundType,
  selectedRefundType,
  handleRefundTypeSelect,
  refundAmountValue,
  setRefundAmountValue,
  customRefundAmount,
  maxValue,
  errorMsg,
  setErrorMsg
}) => {
  const handleRefundAmountChange = (e) => {
    if (e.target.value > maxValue) {
      setErrorMsg({ [selectedRefundType]: 'Exceeds amount received' });
    }
    if (e.target.value <= 0) {
      setErrorMsg({ [selectedRefundType]: 'Must exceed $0.00' });
    }
    if (e.target.value === '') {
      setErrorMsg({ cash: '', partial: '' });
    }
    if (
      e.target.value > 0 &&
      e.target.value !== '' &&
      e.target.value <= maxValue
    ) {
      setErrorMsg({ cash: '', partial: '' });
    }

    setRefundAmountValue({ [selectedRefundType]: e.target.value });
  };

  return (
    <div
      className={`refund-cancel-booking-modal-refund-type-item ${
        selectedRefundType === refundType.value
          ? 'refund-cancel-booking-modal-refund-type-item-checked'
          : ''
      }`}
      onClick={() => handleRefundTypeSelect(refundType.value)}
    >
      <div className='refund-cancel-booking-modal-refund-type-item-container'>
        <div className='refund-cancel-booking-modal-refund-type-item-header'>
          <Radio
            sx={{ padding: 0 }}
            checked={selectedRefundType === refundType.value}
            onChange={() => handleRefundTypeSelect(refundType.value)}
            value={refundType.value}
          />
          <h3 className='refund-cancel-booking-modal-refund-type-item-label'>
            {refundType.label}
          </h3>
        </div>
        {customRefundAmount && refundType.value === 'cash' && (
          <XGInput
            type='number'
            value={refundAmountValue.cash}
            onChange={handleRefundAmountChange}
            error={errorMsg.cash}
            hint={errorMsg.cash}
          />
        )}
        {customRefundAmount && refundType.value === 'partial' && (
          <XGInput
            type='number'
            value={refundAmountValue.partial}
            onChange={handleRefundAmountChange}
            error={errorMsg.partial}
            hint={errorMsg.partial}
          />
        )}
        {refundAmountValue !== undefined && !customRefundAmount && (
          <h3 className='refund-cancel-booking-modal-refund-type-item-amount'>
            {formatCurrency(refundAmountValue)}
          </h3>
        )}
      </div>
    </div>
  );
};

RefundTypeItem.propTypes = {
  refundType: PropTypes.object.isRequired,
  selectedRefundType: PropTypes.string.isRequired,
  handleRefundTypeSelect: PropTypes.func.isRequired,
  refundAmountValue: PropTypes.number,
  setRefundAmountValue: PropTypes.func,
  customRefundAmount: PropTypes.boolean,
  maxValue: PropTypes.number,
  errorMsg: PropTypes.object,
  setErrorMsg: PropTypes.func
};

export default RefundTypeItem;
